import {
  EventStatePayload,
  setInitialPrompt,
  setInitialTalk, // <-- Make sure this is defined in your eventSlice
} from '../../../../../redux/eventSlice';
import ReactQuill from 'react-quill';
import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../../redux/store';

type CreateEventProps = {
  eventObject?: EventStatePayload;
};

const InitialPrompt = ({ eventObject }: CreateEventProps) => {
  const quillRef = useRef(null);
  const dispatch = useDispatch();

  const event = useSelector((state: RootState) => state.event.payload);

  useEffect(() => {
    if (eventObject?.initialPrompt) {
      dispatch(setInitialPrompt(eventObject.initialPrompt));
    }
    if (eventObject?.initialTalk) {
      dispatch(setInitialTalk(eventObject.initialTalk));
    }
  }, [eventObject]); // ✅ Corrected dependency

  const handleContentChange = (value: string) => {
    dispatch(setInitialPrompt(value));
  };

  const handleTalkChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    dispatch(setInitialTalk(e.target.value));
  };

  return (
    <div className="h-full w-full rounded-2xl px-3 pt-7 md:px-8">
      {/* Initial Prompt */}
      <div className="mt-4">
        <b>Initial system prompt</b>
      </div>
      <div className="h-full w-full rounded-[20px] px-3 pt-4 md:px-1">
        <ReactQuill
          ref={quillRef}
          value={event.initialPrompt}
          onChange={handleContentChange}
          style={{ minHeight: '200px' }}
        />
    
      <div className="h-full w-full rounded-[20px] px-3 pt-3 md:px-1">
      <b>Initial talk</b>

        <textarea
          value={event.initialTalk}
          onChange={handleTalkChange}
          rows={6}
          className="w-full rounded-xl border border-gray-300 p-3 focus:outline-none focus:ring-2 focus:ring-blue-400"
          placeholder="Enter initial talk content here..."
        />
      </div>
      </div>



    </div>
  );
};

export default InitialPrompt;
